export function getMethodSchemas(actionDataSchema) {
  var _actionDataSchema$fie;
  return (_actionDataSchema$fie = actionDataSchema.fields) === null || _actionDataSchema$fie === void 0 ? void 0 : _actionDataSchema$fie.map(item => {
    const m = {
      id: `$${item.id}`,
      title: String(item.title),
      description: item.description,
      arguments: item.actionArguments,
      returnValue: item.actionReturnValue
    };
    return m;
  });
}
//# sourceMappingURL=getMethodSchemas.js.map
